export const sizeChartConstants = {
  GET_SINGLE_REQUEST: "SIZE_CHART_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "SIZE_CHART_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "SIZE_CHART_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "SIZE_CHART_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "SIZE_CHART_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "SIZE_CHART_GET_ALL_FAILURE",

  ADD_REQUEST: "SIZE_CHART_ADD_REQUEST",
  ADD_SUCCESS: "SIZE_CHART_ADD_SUCCESS",
  ADD_FAILURE: "SIZE_CHART_ADD_FAILURE",

  UPDATE_REQUEST: "SIZE_CHART_UPDATE_REQUEST",
  UPDATE_SUCCESS: "SIZE_CHART_UPDATE_SUCCESS",
  UPDATE_FAILURE: "SIZE_CHART_UPDATE_FAILURE",

  DELETE_REQUEST: "SIZE_CHART_DELETE_REQUEST",
  DELETE_SUCCESS: "SIZE_CHART_DELETE_SUCCESS",
  DELETE_FAILURE: "SIZE_CHART_DELETE_FAILURE",

  CLEAR: "SIZE_CHART_CLEAR",
};
